import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from './index.module.css'
import { ReversedGradientBorder } from '../commons'
import Link from '../Link'
import Button from '../Button/'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const AboutUsCarousal = ({ title, subtitle, images, ctaText, ctaUrl }) => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
  }
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 450

  return (
    <div className="wrapper">
      <div className={styles.container}>
        <ReversedGradientBorder
          className={styles.gradBorder}
          height="3px"
        ></ReversedGradientBorder>
        <div className={styles.textBox}>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.subtitle}>{subtitle.subtitle}</div>
          {isMobile && (
            <div className={styles.carousal}>
              <Slider {...sliderSettings}>
                {images.map((image, idx) => (
                  <div className={styles.carousalImageContainer} key={idx}>
                    <GatsbyImage
                      image={image.gatsbyImageData}
                      style={{ height: '100%', width: '100%' }}
                      alt={image?.description} />
                  </div>
                ))}
              </Slider>
            </div>
          )}
          <Link to={ctaUrl}>
            <Button className={styles.joinUsButton} inverted>
              {ctaText}
            </Button>
          </Link>
        </div>
        {!isMobile && (
          <div className={styles.carousal}>
            <Slider {...sliderSettings}>
              {images.map((image, idx) => (
                <div className={styles.carousalImageContainer} key={idx}>
                  <GatsbyImage
                    image={image.gatsbyImageData}
                    style={{ height: '100%', width: '100%' }}
                    alt={image?.description} />
                </div>
              ))}
            </Slider>
          </div>
        )}
      </div>
    </div>
  );
}

export default AboutUsCarousal
